import React from 'react';

interface Tab {
  id: string;
  label: string;
}

interface TabsProps {
  tabs: Tab[];
  activeTab: string;
  onTabChange: (tabId: string) => void;
}

const Tabs: React.FC<TabsProps> = ({ tabs, activeTab, onTabChange }) => {
  return (
    <div
      style={{
        backgroundColor: 'var(--bg-primary)',
        borderBottom: '1px solid var(--border-primary)',
        display: 'flex',
        gap: '24px',
        height: '44px',
        padding: '0 24px',
        alignItems: 'flex-end',
      }}
    >
      {tabs.map(tab => {
        const isActive = activeTab === tab.id;
        return (
          <div
            key={tab.id}
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '8px',
              height: '32px',
              alignItems: 'flex-end',
              cursor: 'pointer',
            }}
            onClick={() => onTabChange(tab.id)}
          >
            <div
              style={{
                display: 'flex',
                gap: '4px',
                alignItems: 'center',
              }}
            >
              <span
                style={{
                  fontSize: '14px',
                  fontWeight: isActive ? 600 : 500,
                  color: isActive ? '#E2E8F0' : '#94A3B8', // Use #E2E8F0 for active, #94A3B8 for inactive
                  lineHeight: '20px',
                  fontFamily: 'Inter, sans-serif',
                }}
              >
                {tab.label}
              </span>
            </div>
            <div
              style={{
                backgroundColor: 'var(--accent-primary)',
                height: isActive ? '4px' : '3px',
                opacity: isActive ? 1 : 0,
                borderRadius: '4px 4px 0 0',
                width: '100%',
              }}
            />
          </div>
        );
      })}
    </div>
  );
};

export default Tabs;
